import { render } from "./ChannelUpdate.vue?vue&type=template&id=cd7a2932"
import script from "./ChannelUpdate.vue?vue&type=script&lang=ts"
export * from "./ChannelUpdate.vue?vue&type=script&lang=ts"
script.render = render

export default script